<script setup lang="ts">
import type { Button } from '@autobid/ui/types/components/Button'
import Spinner from '@autobid/ui/components/common/Spinner.vue'
import { SORTING_TYPES } from '@autobid/ui/constants/carsList/SORTING_TYPES'

const result = inject<
  globalThis.Ref<{
    count?: number
  }>
>('result')
const isLoading = inject<globalThis.Ref<boolean>>('isResultLoading')

const listButton = inject<Button>('listButton')

const { url, ...rest } = listButton ?? {}

const route = useRoute()
const linkParams = computed(
  () => `${route.fullPath.split('?')?.[1] ?? ''}&sortingType=${SORTING_TYPES[0]}`,
)
</script>

<template>
  <ElementsButton
    v-if="listButton"
    v-bind="rest"
    class="!relative flex min-h-[60px] !gap-2"
    :disabled="!result?.count"
    :url="result?.count ? `${url}?${linkParams}` : undefined"
  >
    <span>{{ listButton.text }}</span>
    <Spinner v-if="isLoading" class="!h-6 !w-6" />
    <span v-else class="text-xl font-bold">{{ result?.count ?? 0 }}</span>
  </ElementsButton>
</template>
